module.exports = __webpack_public_path__ + "static/media/dryer.939a5631.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/room/rooms/devices/dryer.png
// module id = 42
// module chunks = 0